export const FILTER_ABSOLUTE_VALUE_GREATER_THAN_OR_EQUAL = `absgteq`;
export const FILTER_ABSOLUTE_VALUE_LESS_THAN_OR_EQUAL = `abslteq`;
export const FILTER_EQUAL = `eq`;
export const FILTER_GREATER_THAN = `gt`;
export const FILTER_GREATER_THAN_OR_EQUAL = `gteq`;
export const FILTER_IN = `in`;
export const FILTER_IS_NULL = `isnull`;
export const FILTER_LESS_THAN = `lt`;
export const FILTER_LESS_THAN_OR_EQUAL = `lteq`;
export const FILTER_ICONTAINS = `icontains`;

export class QueryFilter {
	conditions: string[];
	currentPath: string | null;

	static joinCondition(path: string | null, operator: string, value: string) {
		return `${path}|${operator}|${encodeURIComponent(value)}`;
	}

	constructor() {
		this.conditions = [];
		this.currentPath = null;
	}

	absgteq(value: string) {
		return this.addCondition(this.currentPath, FILTER_ABSOLUTE_VALUE_GREATER_THAN_OR_EQUAL, value);
	}

	abslteq(value: string) {
		return this.addCondition(this.currentPath, FILTER_ABSOLUTE_VALUE_LESS_THAN_OR_EQUAL, value);
	}

	addCondition(path: string | null, operator: string, value: string) {
		const newInstance = new QueryFilter();
		newInstance.conditions = this.conditions.concat(
			QueryFilter.joinCondition(path, operator, value)
		);
		newInstance.currentPath = this.currentPath;
		return newInstance;
	}

	eq(value: string) {
		return this.addCondition(this.currentPath, FILTER_EQUAL, value);
	}

	fulltext(value: string) {
		return this.addCondition(this.currentPath, FILTER_ICONTAINS, cleanFulltextSearch(value));
	}

	gt(value: string) {
		return this.addCondition(this.currentPath, FILTER_GREATER_THAN, value);
	}

	gteq(value: string) {
		return this.addCondition(this.currentPath, FILTER_GREATER_THAN_OR_EQUAL, value);
	}

	in(values: string[]) {
		return this.addCondition(this.currentPath, FILTER_IN, values.join(','));
	}

	isnull(value = true) {
		return this.addCondition(this.currentPath, FILTER_IS_NULL, value ? 'true' : 'false');
	}

	lt(value: string) {
		return this.addCondition(this.currentPath, FILTER_LESS_THAN, value);
	}

	lteq(value: string) {
		return this.addCondition(this.currentPath, FILTER_LESS_THAN_OR_EQUAL, value);
	}

	prop(path: string) {
		const newInstance = new QueryFilter();
		newInstance.conditions = this.conditions;
		newInstance.currentPath = path;
		return newInstance;
	}

	toString() {
		return `${this.conditions.join(';')}`;
	}

	valueOf() {
		return this.toString();
	}
}

export function cleanFulltextSearch(value: string) {
	return value.replace(/%00/g, '');
}
